export default "precision mediump float;\n#define GLSLIFY 1\n\nattribute vec3 position;\n\nvoid main() {\n  gl_Position = vec4(position, 1.);\n}\n";